const buildInfo = Object.freeze({
  env: '__ENV__',
  playerVersion: '__PLAYER_VER__',
  playerName: '__PLAYER_NAME__',
  buildTime: '__BUILD_TIME__',
});

export { buildInfo };
